import { planUpscale, type ImageSize, type UpscaleScale } from './domain';

export async function decodeUpscaleImage(blob: Blob): Promise<ImageSize> {
  const bitmap = await createImageBitmap(blob);
  try { return { width: bitmap.width, height: bitmap.height }; }
  finally { bitmap.close(); }
}
export async function verifyUpscaleOutput(blob: Blob, source: ImageSize, scale: UpscaleScale) {
  const signature = new Uint8Array(await blob.slice(0, 8).arrayBuffer());
  if (signature.join(',') !== '137,80,78,71,13,10,26,10') throw new Error('Ảnh kết quả không hợp lệ.');
  const size = await decodeUpscaleImage(blob);
  const plan = planUpscale(source, scale);
  if (size.width !== plan.outputWidth || size.height !== plan.outputHeight) throw new Error('Kích thước ảnh kết quả không đúng.');
  return size;
}
/** The caller owns/revokes the URL, keeping a manual fallback for blocked automatic downloads. */
export function triggerUpscaleDownload(url: string, filename: string) {
  const anchor = document.createElement('a');
  anchor.href = url; anchor.download = filename;
  document.body.appendChild(anchor); anchor.click(); anchor.remove();
}
